var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[_c('t-router-link',{attrs:{"to":_vm.generateProductRoute(_vm.product)}},[_vm._t("default",[_vm._v(_vm._s(_vm._f("st")(_vm.product.name)))])],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }